import React, { useState, useEffect } from 'react';
import { Bio } from '../../data/constants';
import { FaBars, FaTimes } from 'react-icons/fa';
import './styles.css';

const NAV_LINKS = [
  { label: 'Experience', href: '#experience' },
  { label: 'Skills', href: '#skills' },
  { label: 'Projects', href: '#projects' },
  { label: 'Education', href: '#education' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
      <div className="nav__inner">
        <a href="#hero" className="nav__logo">KS<span className="nav__logo-dot">.</span></a>

        <div className="nav__links">
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href} className="nav__link">
              {link.label}
            </a>
          ))}
        </div>

        <a href={Bio.github} target="_blank" rel="noreferrer" className="nav__cta">
          GitHub
        </a>

        <button className="nav__toggle" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {open && (
        <div className="nav__mobile">
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href} className="nav__mobile-link" onClick={() => setOpen(false)}>
              {link.label}
            </a>
          ))}
          <a href={Bio.github} target="_blank" rel="noreferrer" className="nav__mobile-cta" onClick={() => setOpen(false)}>
            GitHub
          </a>
        </div>
      )}
    </nav>
  );
}
